// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1S1tX","content":"GlobalSearch_content__3UUiz"};